export default async function obtenerHistorialPorConcesion (idConcesion) {
    const endpointConceptosPago = `/api/historial/ObtenerHistorialPorIdConcesion/${idConcesion}`;
    const endpointPolizasPago = `/api/historial/ObtenerHistorialPolizasIdConcesion/${idConcesion}`;

    try {
        // Lista de polizas de pago
        const response = await fetch(endpointPolizasPago);
        if (response.status === 400) return [];
        const { data: dataHistorial } = await response.json();

        // Lista de conceptos de pago
        const responseConceptos = await fetch(endpointConceptosPago);
        const { data: dataConceptos } = await responseConceptos.json();

        for (let i = 0; i < dataHistorial.length; i++) {
            dataHistorial[i].conceptos = dataConceptos
                .filter(item => dataHistorial[i].idPolizaPago === item.idPolizaPago)
                .map(item => item.descripcion.toUpperCase());
        }
        return dataHistorial.reverse();
    } catch (error) {
        return [];
    }
}
